import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

interface NotFoundProps {
  message?: string;
}

export default function NotFound({ message }: NotFoundProps) {
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center py-16 text-center">
      <p className="text-6xl font-bold text-slate-200">404</p>
      <h1 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h1>
      <p className="mt-2 max-w-md text-slate-600">
        {message ?? "The page you're looking for doesn't exist or may have been moved."}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button onClick={() => window.history.back()} variant="outline">
          Go back
        </Button>
        <Link to="/search">
          <Button>Search businesses</Button>
        </Link>
      </div>
    </div>
  );
}
